const CTRL_ID = "data-fv-xd-ctrlId"
const XMLACTION = "data-fv-action";
const REPEATER = "[data-fv-repeater]";
const XCTNAME = "data-fv-xd-xctname";


export {
    CTRL_ID,
    XMLACTION,
    REPEATER,
    XCTNAME,
};